// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';


class FeedbackStatus extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      ticket_type: props.match.params.types,
      data_uploaded: false,
      data_error: false,
      ticket: {comment: '',
                status: '',
     }
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }


  componentDidMount() {
    console.log(this.state.id);
  }

  postTicket(data, props) {
    console.log(data);
    const url = `${getLocationOrigin()}/support/update_ticket/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'id': this.state.id,
                                          'ticket_type': this.state.ticket_type,
                                         'comment': data.comment,
                                        'status': data.status});
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){ 
        alert(response.Message);
          props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }
  handleChange(event) {
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.ticket);
    new_selected_one[name] = event.target.value
    this.setState({ticket: new_selected_one});
  }

  handleSubmit(event) {
    event.preventDefault();
    console.log('Submit');
    this.postTicket(this.state.ticket, this.props);
    console.log('post');
    console.log(this.state);
  }

  render() {
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>FeedBack/Queries</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
           <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Status
              </div>
              <select name="status" className="col-md-6" style={styles.item_body}
                onChange={this.handleChange}>
                <option>Select</option>
                  <option value="open">Open</option>
                  <option value="closed">Close</option>
              }
              </select>
            </div>
              <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Comments
              </div>
              <div className="col-md-6 input-group">
                <textarea rows="4" cols="33" id="comments" name="comment" placeholder="Admin Comments" onChange={this.handleChange}>
                {this.state.ticket.comment}
                </textarea>
              </div>
            </div>
            <div style={styles.button_submit} className="col-md-12">
              <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                color:'#ffffff'}}/>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default FeedbackStatus;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/feedbackStatus/index.js